
<template>
<section>
  <ul class="nav nav-pills-primary nav-justified" id="myTab" role="tablist">
    <li class="nav-item">
      <a style="border-top-left-radius: 8px; border-bottom-left-radius: 8px;" class="nav-link active" id="home-tab" data-toggle="tab" href="#active" role="tab" aria-controls="home" aria-selected="true">Active</a>
    </li>
    <li class="nav-item">
      <a style="border-top-right-radius: 8px; border-bottom-right-radius: 8px;" class="nav-link" id="profile-tab" data-toggle="tab" href="#passed" role="tab" aria-controls="profile" aria-selected="false">Resolved</a>
    </li>
  </ul>
  <div class="tab-content" id="myTabContent">
    <div class="tab-pane fade show active" id="active" role="tabpanel" aria-labelledby="home-tab">
      <div class="row mt-20">
        <div v-if="loading" class="col-md-12 text-center">
          <div class="loader"  style="width: 50px;height: 50px;"></div>
        </div>
        <div v-else class="col-md-12">
          <table id="activeTable" class="table table-bordered">
            <thead class="light">
            <tr>
              <th scope="col"></th>
              <th scope="col" class="text-center">Status</th>
              <th scope="col" class="text-center">Test Name</th>
              <th scope="col" class="text-center">Server IP</th>
              <th scope="col" class="text-center">Details</th>
              <th scope="col" class="text-center">Ticket URL</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in activeIncidents" :key="index">
              <td class="text-center" width="2%">
                <div class="dropdown m-auto">
                  <button title="Choose Operation" class="btn settinds-btn btn-sm dropdown-toggle" style="width: 15px!important; padding: 0!important;" type="button" id="dropdownMenuButton1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fa fa-cog"></i>
                  </button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                    <a @click="resolveDomainExpiry(item)" class="dropdown-item" href="javascript:void(0)">Resolve</a>
                    <a @click="openModal(item, 'viewEventsModal')" class="dropdown-item" href="javascript:void(0)">View Details</a>
                    <a @click="loginUser(item)" class="dropdown-item" href="javascript:void(0)">Login User</a>
                    <router-link v-if="item.uid" class="dropdown-item" :to="{ name: 'editUser', params: { docID: item.uid } }">Edit User</router-link>
                  </div>
                </div>
              </td>
              <td class="text-center">
                <div :class="{'status pause': item.domainExpiryStatus === 'active', 'status up': item.domainExpiryStatus === 'passed'}"></div>
              </td>
              <td class="text-center">
                {{showDomainName(item.url)}}
              </td>
              <td class="text-center" >{{ item.serverIP }}</td>
              <td width="25%" class="text-center">
                <span v-html="getDetails(item.domainExpiryIncidents)"></span>
              </td>
              <td class="text-center">
                <a v-if="item.domainExpiryIncidents[item.domainExpiryIncidents.length - 1] && item.domainExpiryIncidents[item.domainExpiryIncidents.length - 1].ticketId" :href="`https://portal.bigscoots.com/admin/?cmd=tickets&action=view&brc=MTA&list=requirescustomerupdate&num=${item.domainExpiryIncidents[item.domainExpiryIncidents.length - 1].ticketId}`" target="_blank">
                  <i  title="View Ticket" class="text-primary fa fa-eye ml-2"></i>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="tab-pane fade" id="passed" role="tabpanel" aria-labelledby="profile-tab">
      <div class="row mt-20">
        <div v-if="loading" class="col-md-12 text-center">
          <div class="loader"  style="width: 50px;height: 50px;"></div>
        </div>
        <div v-else class="col-md-12">
          <table id="passedTable" class="table table-bordered">
            <thead class="light">
            <tr>
              <th scope="col"></th>
              <th scope="col" class="text-center">Status</th>
              <th scope="col" class="text-center">Test Name</th>
              <th scope="col" class="text-center">Server IP</th>
              <th scope="col" class="text-center">Details</th>
              <th scope="col" class="text-center">Ticket URL</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in passedIncidents" :key="index">
              <td class="text-center" width="2%">
                <div class="dropdown m-auto">
                  <button title="Choose Operation" class="btn settinds-btn btn-sm dropdown-toggle" style="width: 15px!important; padding: 0!important;" type="button" id="dropdownMenuButton1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fa fa-cog"></i>
                  </button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                    <a @click="openModal(item, 'viewEventsModal')" class="dropdown-item" href="javascript:void(0)">View Details</a>
                    <a @click="loginUser(item)" class="dropdown-item" href="javascript:void(0)">Login User</a>
                    <router-link v-if="item.uid" class="dropdown-item" :to="{ name: 'editUser', params: { docID: item.uid } }">Edit User</router-link>
                  </div>
                </div>
              </td>
              <td class="text-center">
                <div :class="{'status pause': item.domainExpiryStatus === 'active', 'status up': item.domainExpiryStatus === 'passed'}"></div>
              </td>
              <td class="text-center">
                {{showDomainName(item.url)}}
              </td>
              <td class="text-center" >{{ item.serverIP }}</td>
              <td width="25%" class="text-center">
                <span v-html="getDetails(item.domainExpiryIncidents)"></span>
              </td>
              <td class="text-center">
                <a v-if="item.domainExpiryIncidents[item.domainExpiryIncidents.length - 1] && item.domainExpiryIncidents[item.domainExpiryIncidents.length - 1].ticketId" :href="`https://portal.bigscoots.com/admin/?cmd=tickets&action=view&brc=MTA&list=requirescustomerupdate&num=${item.domainExpiryIncidents[item.domainExpiryIncidents.length - 1].ticketId}`" target="_blank">
                  <i  title="View Ticket" class="text-primary fa fa-eye ml-2"></i>
                </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>
import {db} from "@/firebase/init";
import moment from "moment/moment";
import _ from "lodash";
import swal from "sweetalert2";

export default {
  data() {
    return {
      loading: false,
      allDomainExpiryIncidents: [],
      listener: null
    }
  },
  computed: {
    activeIncidents() {
      console.log(this.allDomainExpiryIncidents.filter(el => el.domainExpiryIncidents === 'active'))
      return this.allDomainExpiryIncidents.filter(el => el.domainExpiryStatus === 'active').sort((a,b)=> new Date(b.domainExpiryIncidents[b.domainExpiryIncidents.length - 1].startedAt) - new Date (a.domainExpiryIncidents[a.domainExpiryIncidents.length - 1].startedAt))
    },
    passedIncidents() {
      console.log(this.allDomainExpiryIncidents.filter(el => el.domainExpiryIncidents === 'passed'))
      return this.allDomainExpiryIncidents.filter(el => el.domainExpiryStatus === 'passed').sort((a,b)=> new Date(b.domainExpiryIncidents[b.domainExpiryIncidents.length - 1].startedAt) - new Date (a.domainExpiryIncidents[a.domainExpiryIncidents.length - 1].startedAt))
    }
  },
  beforeDestroy() {
    if(this.listener) {
      this.listener()
    }
  },
  watch: {
    allDomainExpiryIncidents() {
      this.renderDatatable()
    }
  },
  mounted() {
  },
  methods: {
    loginUser(item) {
      if(item.uid) {
        swal({
          title: item.firstName + ' ' + item.lastName,
          text: 'Would you like to login to this customer\'s WPO account',
          type: "question",
          confirmButtonText: "Yes Proceed",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "No Thanks",
          cancelButtonColor: "#EE8057"
        }).then( result => {
          if(result.value){
            this.goToNuxt(item.uid);
          }
        });
      }
    },
    async goToNuxt (docId) {
      this.gotoNuxtLoader = true
      await this.saveRecentlyAccessedUserToDB(docId)
      this.gotoNuxtLoader = false
      window.open(`https://wpo.bigscoots.com/user/dashboard?id=${docId}`,'WPO-Bigscoots');
    },
    timeDifferenceBetweenGivenDates(laterDate, smallDate){
      let a = moment.utc(laterDate);
      let b = moment.utc(smallDate);
      let ms = a.diff(b);
      let d = moment.duration(ms);
      return d.format("HH:mm:ss");
    },
    async resolveDomainExpiry(row) {
      try {
        console.log(`row ${(row)}`)
        const response = await this.$http.post('/monitor/resolve-domain-expiry-incident',{
          grant_type: 'token',
          incidentId: row.domainExpiryIncidents[row.domainExpiryIncidents.length - 1].incidentId || '',
          monitorId: row.id
        });
        console.log('response of api', response.data);
        if(response.data.success) {
          swal('Success', 'You have successfully resolved the domain expiry incident', 'success');
        }
      } catch (e) {
        swal('Error', 'Something went wrong while resolving domain expiry incident', 'error');
      }
    },
    openModal(test, el){
      if(el === 'viewEventsModal'){
        this.$parent.selectedItemForView = _.cloneDeep(test);
        this.$parent.eventsShowAll = false
        this.$parent.notesShowAll = false
        this.$parent.modalOpenedFrom = 'domainExpiry'
        this.$parent.notesPageSize = 5
        this.$parent.notesPageNumber = 0
        this.$parent.pageNumber = 0
        this.$parent.pageSize = 5
        this.$parent.selectedItemForView.incidents.reverse();
        if(this.$parent.selectedItemForView.notes !== undefined){
          this.$parent.selectedItemForView.notes.reverse();
        }
        let durations = [];
        for(let event of this.$parent.selectedItemForView.incidents){
          if(event.status === 'down' && event.end !== undefined){
            let dur = this.timeDifferenceBetweenGivenDates(event.end, event.start);
            if(dur.split(':').length === 2){
              durations.push("00:" + dur);
            }else if(dur.split(':').length === 1){
              durations.push("00:00:" + dur);
            }else{
              durations.push(dur);
            }
          }
        }
        const totalDurations = moment.duration();
        durations.map(duration => {
          totalDurations.add(duration);
        });
        this.$parent.totalDownDurationOfSelectedItem = moment.utc(totalDurations.asMilliseconds()).format("HH:mm:ss");
      }else{
        this.$parent.selectedItemForView = test;
      }
      /* eslint-disable */
      $("#" + el).modal("show");
      $('.modal-backdrop').removeClass("modal-backdrop");
      /* eslint-enable */
    },
    load() {
      this.fetchIncidents()
      this.renderDatatable()
    },
    renderDatatable() {
      console.log('rendering')
      if($.fn.DataTable.isDataTable('#activeTable')) {
        $(`#activeTable`).DataTable().destroy();
      }
      setTimeout(function () {
        $(`#activeTable`).dataTable({
          pagingType: "full_numbers",
          paging: true,
          destroy: true,
          retrieve: true,
          deferRender: true,
          stateSave: true,
          "bInfo" : false,
          "ordering": true,
          "columnDefs": [
            { "orderable": false, "targets": [0,1, 5] }  // Disable sorting on the first column (index 0)
          ]
        });
      }, 0)
      if($.fn.DataTable.isDataTable('#passedTable')) {
        $(`#passedTable`).DataTable().destroy();
      }
      setTimeout(function () {
        $(`#passedTable`).dataTable({
          pagingType: "full_numbers",
          paging: true,
          destroy: true,
          retrieve: true,
          deferRender: true,
          stateSave: true,
          "bInfo" : false,
          "ordering": true,
          "columnDefs": [
            { "orderable": false, "targets": [0,1, 5] }  // Disable sorting on the first column (index 0)
          ]
        });
      }, 0)
    },
    showDomainName (url) {
      const domainName = url.replace('https://', '').split('/?v=')[0];
      return domainName;
    },
    getDetails(incidents) {
      const lastIncident = incidents[incidents.length - 1];
      let details = ''

      if(lastIncident) {
        const date = moment(lastIncident.startedAt);
        const estDate = date.tz("America/New_York");
        // Format the EST date
        const formattedEstDate = estDate.format("DD MMM YYYY");
        details = `<span>Incident received: ${formattedEstDate} (EST) <br> Time Left in Expiry at the time of Incident: ${lastIncident.domain_expiration_time_left}</span>`
      }
      return details
    },
    fetchIncidents() {
      try {
        this.loading = true;
        this.allDomainExpiryIncidents = []

        const ref = db.collection('monitors').where('domainExpiryStatus', 'in', ['active', 'passed']);
        this.listener = ref.onSnapshot(querySnapshot => {
          querySnapshot.docChanges().forEach(change => {
            const data = change.doc.data();
            console.log(change.type)
            switch (change.type) {
              case 'added':
                this.allDomainExpiryIncidents.push({id: change.doc.id, ...data});
                break;
              case 'modified':
                this.allDomainExpiryIncidents = this.allDomainExpiryIncidents.filter(el => el.id !== change.doc.id);
                this.allDomainExpiryIncidents.push({id: change.doc.id, ...data})
                break;
            }
          });
        })
        console.log('ref', ref.size)
        if(ref.size) {
          ref.forEach(el => {
            this.allDomainExpiryIncidents.push({id: el.id, ...el.data()});
          });
        }
        this.loading = false;
      } catch (e) {
        console.log('error', e.toString())
      }
    }
  }
}
</script>
<style scoped>

.settinds-btn, .settinds-btn:active, .settinds-btn:focus {
  background-color: transparent!important;
  color: black!important;
}
.settinds-btn:hover {
  background-color: black!important;
  color: white !important;
}
.dropdown-toggle:after {
  display: none;
}
table{
  thead{
    background-color: #f2f2f2 !important;
    th{
      text-transform: none;
    }
  }
  td {
    padding: 0px
  }
}
.sc-status.down {
  background-color: #a51f1f;
}
.status {
  width: 20px;
  border-radius: 50%;
  height: 20px;
  display: inline-block;
}
.up {
  background-color: #6aa529;
}

.pause{
  background-color: #f29f3f;
}
code{
  color: #007bff !important;
}
</style>